var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -1028.4)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m5 1032.4c-1.1046 0-2 0.9-2 2v14c0 1.1 0.8954 2 2 2h14c1.105 0 2-0.9 2-2v-14c0-1.1-0.895-2-2-2h-14z",
  fill: "#bdc3c7"
}), /*#__PURE__*/React.createElement("path", {
  transform: "translate(0 1028.4)",
  d: "m5 3c-1.1046 0-2 0.8954-2 2v14c0 1.105 0.8954 2 2 2h14c1.105 0 2-0.895 2-2v-14c0-1.1046-0.895-2-2-2h-14z",
  fill: "#ecf0f1"
}), /*#__PURE__*/React.createElement("path", {
  transform: "translate(0 1028.4)",
  d: "m5 3c-1.1046 0-2 0.8954-2 2v4h18v-4c0-1.1046-0.895-2-2-2h-14z",
  fill: "#e74c3c"
}), /*#__PURE__*/React.createElement("path", {
  transform: "translate(.5 1028.4)",
  d: "m7 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 1 1 3 0z",
  fill: "#c0392b"
}), /*#__PURE__*/React.createElement("path", {
  transform: "translate(12.5 1028.4)",
  d: "m7 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 1 1 3 0z",
  fill: "#c0392b"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#bdc3c7"
}, /*#__PURE__*/React.createElement("path", {
  d: "m5 1039.4v2h2v-2h-2zm3 0v2h2v-2h-2zm3 0v2h2v-2h-2zm3 0v2h2v-2h-2zm3 0v2h2v-2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m5 1042.4v2h2v-2h-2zm3 0v2h2v-2h-2zm3 0v2h2v-2h-2zm3 0v2h2v-2h-2zm3 0v2h2v-2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m5 1045.4v2h2v-2h-2zm3 0v2h2v-2h-2zm3 0v2h2v-2h-2zm3 0v2h2v-2h-2zm3 0v2h2v-2h-2z"
})), /*#__PURE__*/React.createElement("path", {
  transform: "translate(0 1028.4)",
  d: "m6 1c-0.5523 0-1 0.4477-1 1v3c0 0.5523 0.4477 1 1 1s1-0.4477 1-1v-3c0-0.5523-0.4477-1-1-1zm12 0c-0.552 0-1 0.4477-1 1v3c0 0.5523 0.448 1 1 1s1-0.4477 1-1v-3c0-0.5523-0.448-1-1-1z",
  fill: "#95a5a6"
}), /*#__PURE__*/React.createElement("path", {
  d: "m6 1029.4c-0.5523 0-1 0.4-1 1v2h2v-2c0-0.6-0.4477-1-1-1zm12 0c-0.552 0-1 0.4-1 1v2h2v-2c0-0.6-0.448-1-1-1z",
  fill: "#bdc3c7"
}));

function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendarIcon.480d00ef49c5c8d3b7637a20c8dbbde4.svg";
export { ForwardRef as ReactComponent };